import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const FitnessExercise = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 fit-ex">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                        <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                            <Trans>Elevate <br/>Employee Fitness</Trans>
                        </h1>
                        <p className="hero-para font-weight-semibold no-br">
                            <Trans>Involve your team in organized workouts and monitor <br/>their exercise routines. Empower them to take <br/>charge of their fitness journey.</Trans>
                        </p>
                        <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>


            <section className="position-relative pl-0 pr-0">
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container d-flex m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5 mb-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label red-font">
                                        <Trans>Quick Fitness Breaks</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>7-Minute Workout</Trans></h2>
                                    <p className='section-para font-weight-normal greenTick'><Trans>Add a quick 7-minute workout to your employees' schedules for an instant energy boost at work.</Trans></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img p-0'>
                                <div className='d-flex justify-content-end px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706164202/VantageFit/2023/Fitness_tracker-7-minutes_workout`)} fetchPriority="high" alt="7-Minute Workout" width="621" height="760"/>
                                </div>
                            </div>
                        </div>
                        <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label green-font">
                                        <Trans>Build Strength Daily</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Squat Tracker</Trans></h2>
                                    <p className='section-para font-weight-normal greenTick'><Trans>Enable your team to track squats, build strength and celebrate milestones with the top-notch AI Squat Tracker.</Trans></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img px-0'>
                                <div className='col-12 d-flex justify-content-start px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706164203/VantageFit/2023/Fitness_tracker-Squats_tracker`)} loading='lazy' alt="Squat Tracker" width="621" height="760"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative container">
                <div className="section-heading-top cursive">
                    <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat3">Tailored&nbsp;<span className="charmonman green-clr">Fitness</span>&nbsp;for Your Team</Trans>&nbsp;!</h2>
                    <div className="section-para text-center no-br"><Trans>Deliver a customized, gamified workout experience designed to <br/>suit your team's work-life balance.</Trans></div>
                </div>
            </section>
            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="font-weight-semibold section-heading text-center no-br">
                            <Trans>Transforming your <br/>Team's Fitness Experience!</Trans>
                        </h2>
                        <p className="sub-para font-weight-normal text-center mb-5 text-white">
                            <Trans>Ready to revolutionize your employees' fitness routines? Begin with us.</Trans>
                        </p>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FitnessExercise;
